// FIFA 3-letter code → flag emoji + full country name.
// Used by the Black 1/1 Tracker to render country flags and full names
// without shipping any new image assets.

export const FLAG_BY_FIFA = {
  ALG:"🇩🇿", ARG:"🇦🇷", AUS:"🇦🇺", AUT:"🇦🇹", BEL:"🇧🇪", BIH:"🇧🇦", BRA:"🇧🇷",
  CAN:"🇨🇦", CIV:"🇨🇮", COD:"🇨🇩", COL:"🇨🇴", CPV:"🇨🇻", CRO:"🇭🇷", CUW:"🇨🇼",
  CZE:"🇨🇿", ECU:"🇪🇨", EGY:"🇪🇬", ENG:"🏴󠁧󠁢󠁥󠁮󠁧󠁿", ESP:"🇪🇸", FRA:"🇫🇷",
  GER:"🇩🇪", GHA:"🇬🇭", HAI:"🇭🇹", IRN:"🇮🇷", IRQ:"🇮🇶", JOR:"🇯🇴", JPN:"🇯🇵",
  KOR:"🇰🇷", KSA:"🇸🇦", MAR:"🇲🇦", MEX:"🇲🇽", NED:"🇳🇱", NOR:"🇳🇴", NZL:"🇳🇿",
  PAN:"🇵🇦", PAR:"🇵🇾", POR:"🇵🇹", QAT:"🇶🇦", RSA:"🇿🇦", SCO:"🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  SEN:"🇸🇳", SUI:"🇨🇭", SWE:"🇸🇪", TUN:"🇹🇳", TUR:"🇹🇷", URU:"🇺🇾", USA:"🇺🇸",
  UZB:"🇺🇿", WAL:"🏴󠁧󠁢󠁷󠁬󠁳󠁿",
};

export const COUNTRY_NAME_BY_FIFA = {
  ALG:"Algeria", ARG:"Argentina", AUS:"Australia", AUT:"Austria", BEL:"Belgium",
  BIH:"Bosnia and Herzegovina", BRA:"Brazil", CAN:"Canada", CIV:"Ivory Coast",
  COD:"DR Congo", COL:"Colombia", CPV:"Cape Verde", CRO:"Croatia", CUW:"Curaçao",
  CZE:"Czechia", ECU:"Ecuador", EGY:"Egypt", ENG:"England", ESP:"Spain",
  FRA:"France", GER:"Germany", GHA:"Ghana", HAI:"Haiti", IRN:"Iran",
  IRQ:"Iraq", JOR:"Jordan", JPN:"Japan", KOR:"South Korea", KSA:"Saudi Arabia",
  MAR:"Morocco", MEX:"Mexico", NED:"Netherlands", NOR:"Norway", NZL:"New Zealand",
  PAN:"Panama", PAR:"Paraguay", POR:"Portugal", QAT:"Qatar", RSA:"South Africa",
  SCO:"Scotland", SEN:"Senegal", SUI:"Switzerland", SWE:"Sweden", TUN:"Tunisia",
  TUR:"Türkiye", URU:"Uruguay", USA:"United States", UZB:"Uzbekistan", WAL:"Wales",
};

export const flagOf = (cc) => FLAG_BY_FIFA[(cc || "").toUpperCase()] || "";
export const countryOf = (cc) => COUNTRY_NAME_BY_FIFA[(cc || "").toUpperCase()] || cc || "";

// Extract the "family" name to use as the visual hero on cards where space is
// tight. Falls back to the full name if we can't parse it.
export const familyNameOf = (fullName) => {
  if (!fullName) return "";
  const trimmed = fullName.replace(/\s+/g, " ").trim();
  // Team stickers usually read "Argentina Team" — keep the country portion.
  if (/\bTeam$/i.test(trimmed)) return trimmed.replace(/\s+Team$/i, "").trim();
  const parts = trimmed.split(" ");
  return parts.length <= 1 ? trimmed : parts.slice(1).join(" ");
};
